// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-header-brand[data-v-9204a0aa]{align-items:center;display:flex}.the-header-brand__image[data-v-9204a0aa]{max-height:var(--unit-0800)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
